export default __webpack_public_path__ + "463daa55d83934e98cfc74776868a3e7.png";